import styled from 'styled-components';

export const ColorSectionWrapper = styled.section`
  margin-top: 1.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
`;
